<template>
  <div
    class="w-[351px] h-screen border-r-2 border-gray-300/30 flex flex-col gap-y-2 transition-all duration-400 ease-in-out"
    :class="{ 'sm:w-[80px]': menuCollapsed }">
    <div class="px-3 pt-3">
      <div class="flex items-center h-7">
        <img
          v-if="!companyLogo"
          class="w-10 my-auto"
          :class="{ 'hidden': menuCollapsed }"
          src="@/assets/images/logo.png" />
        <img
          v-if="companyLogo"
          class="w-10"
          :class="{ 'hidden': menuCollapsed }"
          :src="companyLogo" />
        <span
          class="flex-1 ml-2 text-sm font-semibold cursor-pointer text-theme-600"
          :class="{ 'hidden': menuCollapsed }"
          @click="router.push('/dashboard')">
          Mobile World
        </span>
        <img
          class="w-4 h-full mx-auto my-auto cursor-pointer"
          src="@/assets/images/menu.svg"
          @click="onMenuExpandCollapse()" />
      </div>
      <div class="mt-4">
        <SearchList
          v-if="!menuCollapsed"
          class="text-sm bg-gray-100"
          :placeholder="$t('common.actions.search')"
          v-model="searchInput" />
      </div>
    </div>
    <PerfectScrollbar class="flex flex-col flex-1 h-full px-3" ref="sidebarid">
      <div v-show="activeTab == 'Favourites' && !menuCollapsed" class="flex-1">
        <FavoritesMenu
          ref="favoritesMenu"
          :search-term="activeTab == 'Favourites' ? searchInput : undefined"
          :filter-function="filterFavoriteMenu"
          @update-favorites="onFavoritesUpdate" />
      </div>
      <div v-show="activeTab == 'Menu'">
        <div v-for="(item, index) in activeMenu" :key="index">
          <div
            class="flex h-12 pl-1 mt-1 transition duration-500 ease-in-out rounded-md cursor-pointer"
            :class="item.isExpanded && !menuCollapsed ? 'bg-theme-600' : 'hover:bg-theme-100'"
            @click="rootItemClicked(item)"
            v-if="item && item.isVisible">
            <div class="flex items-center justify-center w-12">
              <Icon
                :icon="item.icon"
                class="w-5 h-5"
                :class="item.isExpanded && !menuCollapsed ? 'text-theme-100' : 'text-theme-600'" />
            </div>
            <span
              class="flex-1 my-auto text-sm truncate"
              :class="menuCollapsed ? 'hidden' : item.isExpanded ? ' text-white' : 'text-black'"
              >{{ item.name }}</span
            >
            <div
              v-if="item.children && item.children.length > 0 && !menuCollapsed"
              class="flex items-center justify-center mx-2">
              <Icon
                icon="carbon:chevron-down"
                class="w-4 h-4 transition duration-200 ease-in-out text-theme-600"
                :class="{ 'rotate-180 text-white': item.isExpanded }" />
            </div>
          </div>

          <div
            v-if="
              item &&
              item.isExpanded &&
              item.children &&
              item.children.filter((x: any) => x.isVisible === true).length > 0 &&
              !menuCollapsed
            ">
            <div v-for="(child, index) in item.children" :key="index">
              <div
                class="flex items-center mt-1 transition duration-500 ease-in-out rounded-md cursor-pointer h-9 hover:bg-theme-100"
                :class="{ 'bg-theme-100': child.isExpanded }"
                @click="child.isExpanded = !child.isExpanded">
                <button class="flex items-center justify-center w-12 text-theme-400">
                  <Icon
                    v-if="child.children"
                    icon="carbon:chevron-right"
                    class="transition duration-200 ease-in-out origin-center"
                    :class="{ 'rotate-90': child.isExpanded }" />
                </button>
                <span
                  class="text-sm grow"
                  :class="{ 'text-theme-600': child.isExpanded && child.pathName }"
                  @click="
                    {
                      if (child.pathName) router.push(child.pathName);
                    }
                  "
                  >{{ child.name }}</span
                >
                <button
                  v-if="child.isFavoriteActive"
                  class="flex justify-end w-12 pt-1 pr-4 text-theme-400"
                  @blur="focusedMenuItem = undefined"
                  @click="favouriteClicked(child)">
                  <Icon
                    :icon="
                      focusedMenuItem == child.name
                        ? 'fluent:heart-24-filled'
                        : 'fluent:heart-24-regular'
                    "
                    class="w-4 h-4 cursor-pointer text-slate-400 hover:text-theme-500" />
                </button>
              </div>

              <div
                v-if="
                  child.isExpanded &&
                  child.children &&
                  child.children.filter((x: any) => x.isVisible === true).length > 0
                ">
                <div v-for="(grandKid, index) in child.children" :key="index">
                  <div
                    class="flex items-center h-10 pl-12 mt-1 transition duration-500 ease-in-out rounded-sm shadow-sm cursor-pointer hover:bg-slate-100"
                    :class="{ 'bg-slate-100': grandKid.isExpanded && !grandKid.isFutureWork }"
                    @click="leafItemClicked(grandKid)">
                    <span
                      class="text-xs leading-4 basis-5/6"
                      :class="child.isExpanded ? 'text-theme-600' : 'text-slate-500'"
                      >{{ grandKid.name }}</span
                    >
                    <div v-if="grandKid.isWorkInProgress" class="text-center">
                      <span
                        class="justify-center px-2.5 py-0.5 mx-1 text-xs font-normal text-green-500 bg-green-50 rounded-full border border-green-200">
                        wip
                      </span>
                    </div>
                    <div v-if="grandKid.isFutureWork" class="text-center">
                      <span
                        class="justify-center px-2.5 py-0.5 mx-1 text-xs font-normal text-yellow-500 bg-yellow-50 rounded-full border border-yellow-200">
                        future
                      </span>
                    </div>
                    <button
                      class="flex justify-end w-12 pt-1 pr-4 text-theme-400"
                      @blur="focusedMenuItem = undefined"
                      @click="favouriteClicked(grandKid)">
                      <Icon
                        :icon="
                          focusedMenuItem == grandKid.name
                            ? 'fluent:heart-24-filled'
                            : 'fluent:heart-24-regular'
                        "
                        class="w-4 h-4 cursor-pointer text-slate-400 hover:text-theme-500" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="w-full h-px mt-6 bg-gray-200"></div>
        <div v-if="!menuCollapsed" class="transition duration-500 ease-in-out">
          <div class="text-[13px] font-medium uppercase text-slate-400 px-3.5 pt-5 pb-2.5">
            my menus
          </div>
          <div
            v-for="menu in pinnedMenus"
            :key="menu.key"
            class="flex flex-col gap-1 text-sm font-medium rounded-md"
            @contextmenu.prevent="showContextMenu($event, menu.key)">
            <input
              v-if="
                favoritesMenu?.showRenameInput && favoritesMenu?.contextMenuTargetKey == menu.key
              "
              type="text"
              ref="renameInputMain"
              v-model="menu.name"
              class="p-2 border border-theme-500 bg-theme-200 focus:outline-theme-500"
              @keyup.enter="onMenuRename"
              @blur="onMenuRename" />
            <div
              v-else
              tabindex="0"
              class="flex gap-4 items-center p-2.5 rounded-md cursor-pointer text-theme-500"
              :class="{ 'cursor-pointer': menu.items.length }"
              @click="onFavoriteMenuClick(menu.key)">
              <Icon
                icon="carbon:pin-filled"
                width="24"
                @click="onFavoriteMenuUnpin(menu.key)"
                :class="menu.color" />
              {{ menu.name }}
              <Icon
                v-if="menu.items.length"
                icon="carbon:chevron-down"
                class="ml-auto transition duration-200 ease-in-out text-theme-600"
                width="16"
                :class="{ 'rotate-180': menu.isExpanded }" />
            </div>

            <!-- menu items -->
            <div v-if="menu.isExpanded">
              <div
                v-for="(item, index) in menu.items"
                :key="index"
                class="flex justify-between items-center p-2.5 font-light rounded-md cursor-pointer hover:bg-slate-100 hover:text-theme-600 text-slate-600"
                @click="
                  {
                    if (item.pathName) router.push(item.pathName);
                  }
                ">
                {{ item.name }}
                <Icon
                  icon="fluent:heart-24-filled"
                  class="w-4 h-4 text-slate-400 hover:text-theme-500"
                  @click="onFavoriteMenuRemoveItem(menu.key, index)" />
              </div>
            </div>
          </div>
        </div>
        <ContextMenu
          ref="menu"
          :options="contextMenuOptions"
          class="fixed"
          :style="{ top: clickLocation.y + 'px', left: clickLocation.x + 'px' }"
          :isDropdownOpen="isContextMenuOpen"
          @action="onContextMenuAction($event)"
          @close="isContextMenuOpen = false" />
      </div>
    </PerfectScrollbar>

    <div class="flex" :class="menuCollapsed ? 'flex-col h-48' : 'h-16'">
      <TooltipButton
        tooltip-text="Menu"
        class="border-t-2 border-r-2 border-gray-100 basis-1/3"
        :class="{ 'bg-cyan-light': activeTab == 'Menu' }"
        @click="onTooltipButtonClick('Menu')">
        <template #buttonContent>
          <button class="w-full h-full">
            <img src="@/assets/images/menu-alt.svg" class="w-5 h-5 mx-auto my-auto" />
          </button>
        </template>
      </TooltipButton>
      <TooltipButton
        tooltip-text="Favourites"
        class="border-t-2 border-r-2 border-gray-100 basis-1/3"
        :class="{ 'bg-cyan-light': activeTab == 'Favourites' }"
        @click="onTooltipButtonClick('Favourites')">
        <template #buttonContent>
          <button class="w-full h-full">
            <img src="@/assets/images/heart.svg" class="w-5 h-5 mx-auto my-auto" />
          </button>
        </template>
      </TooltipButton>
      <TooltipButton
        tooltip-text="Settings"
        class="border-t-2 border-r-2 border-gray-100 basis-1/3">
        <template #buttonContent>
          <button class="w-full h-full" @click="router.push('/settings/my-account')">
            <img src="@/assets/images/settings-blue.svg" class="w-5 h-5 mx-auto my-auto" />
          </button>
        </template>
      </TooltipButton>
    </div>
    <InfoModal
      v-if="showAddToMenuModal"
      :title="favoriteMenus.length ? 'Add to My Menus' : 'No menus'"
      :text="favoriteMenus.length == 0 ? 'Create a new one.' : ''"
      primary-button-text="cancel"
      :secondary-button-text="favoriteMenus.length == 0 ? 'Create' : 'Add'"
      @primary-button-clicked="showAddToMenuModal = false"
      @secondary-button-clicked="onAddItemToMenu">
      <template #default v-if="favoriteMenus.length">
        <SingleSelect
          v-model="selectedMenu"
          :options="favoriteMenus"
          item-text="name"
          placeholder="Select a Menu"
          class="h-8 mb-8" />
      </template>
    </InfoModal>
  </div>
</template>

<script setup lang="ts">
import { ref, watch, nextTick, computed, onMounted } from 'vue';
import { Icon } from '@iconify/vue';
import SearchList from '@/components/common/SearchList.vue';
import TooltipButton from '../TooltipButton.vue';
import FavoritesMenu from './FavoritesMenu.vue';
import ContextMenu from './ContextMenu.vue';
import InfoModal from '../InfoModal.vue';
import SingleSelect from '../SingleSelect.vue';
import type { ContextMenuOptions, FavoriteMenu, FavoriteMenuItem } from '@/types/ComponentTypes';
import { useRouter } from 'vue-router';
import type { PerfectScrollbarExpose } from 'vue3-perfect-scrollbar';
import { useI18n } from 'vue-i18n';
import { useModulesStore } from '@/stores/modules';
import type { ModuleInstallation } from '@/types/MW';

type MenuItem = {
  name: string;
  icon: string;
  isVisible: boolean;
  isExpanded: boolean;
  children?: MenuItem[] | null;
  pathName?: string;
  isWorkInProgress?: boolean;
  isFutureWork?: boolean;
  isFavoriteActive?: boolean;
  tag?: string;
};

const { t: $t } = useI18n();
const {
  GENERAL,
  LOGISTICS,
  SALESSUPERVISION,
  TRANSACTIONS,
  MANAGERREPORTING,
  TRADERSMANAGEMENT,
  SALES,
  DOCUMENTSMANAGEMENT,
  TPTRADEPOLICYMANAGEMENT,
  QUESTIONNAIRES,
  ROUTES,
  PRICECOLLECTION,
  WRHOUSEMANAGEMENT,
  GENERALGROUPING,
  REPRESENTATIVES,
} = useModulesStore();

const activeTab = ref<'Menu' | 'Favourites'>('Menu');
const router = useRouter();
const focusedMenuItem = ref();
const menuCollapsed = ref(false);
const menuItems = ref<MenuItem[]>([]);

const applicationsMenuItems = ref<MenuItem[]>([
  {
    tag: GENERAL,
    name: `${$t('sidebar.general')}`,
    icon: '@menu:md:dashboard',
    isVisible: true,
    isExpanded: false,
  },
  {
    tag: LOGISTICS,
    name: `${$t('sidebar.logistics')}`,
    icon: '@menu:md:xvan',
    isVisible: true,
    isExpanded: false,
  },
  {
    tag: SALESSUPERVISION,
    name: `${$t('sidebar.salesSupervision')}`,
    icon: '@menu:md:sales-supervision',
    isVisible: true,
    isExpanded: false,
  },
  {
    tag: TRANSACTIONS,
    name: `${$t('sidebar.transactions')}`,
    icon: '@menu:md:transactions',
    isVisible: true,
    isExpanded: false,
  },
  {
    name: `${$t('sidebar.xvan')}`,
    icon: '@menu:md:xvan',
    isVisible: true,
    isExpanded: false,
  },
]);

const modulesMenuItems = ref<MenuItem[]>([
  {
    tag: TRADERSMANAGEMENT,
    name: `${$t('sidebar.traders')}`,
    icon: '',
    isVisible: true,
    isExpanded: false,
    children: [
      {
        name: `${$t('pages.traders')}`,
        icon: '',
        isVisible: true,
        isExpanded: false,
        pathName: '/traders',
      },
      {
        name: `${$t('pages.trader-sites')}`,
        icon: '',
        isVisible: true,
        isExpanded: false,
        pathName: '/trader-sites',
      },
      {
        name: `${$t('pages.customers')}`,
        icon: '',
        isVisible: true,
        isExpanded: false,
        pathName: '/customers',
      },
      {
        name: `${$t('pages.competitor-types')}`,
        icon: '',
        isVisible: true,
        isExpanded: false,
        pathName: '/competitor-types',
      },
      {
        name: `${$t('pages.competitors')}`,
        icon: '',
        isVisible: true,
        isExpanded: false,
        pathName: '/competitors',
      },
      {
        name: `${$t('pages.competitor-materials')}`,
        icon: '',
        isVisible: true,
        isExpanded: false,
        pathName: '/competitor-materials',
      },
    ],
  },
  {
    tag: WRHOUSEMANAGEMENT,
    name: `${$t('sidebar.warehouse')}`,
    icon: '',
    isVisible: true,
    isExpanded: false,
    children: [
      {
        name: `${$t('pages.materials-management')}`,
        icon: '',
        isVisible: true,
        isExpanded: false,
        pathName: '/materials-management',
      },
      {
        name: `${$t('pages.warehouses-management')}`,
        icon: '',
        isVisible: true,
        isExpanded: false,
        pathName: '/warehouses',
      },
      {
        name: `${$t('pages.assortments-management')}`,
        icon: '',
        isVisible: true,
        isExpanded: false,
        pathName: '/assortments-management',
      },
      {
        name: `${$t('pages.ranges-management')}`,
        icon: '',
        isVisible: true,
        isExpanded: false,
        pathName: '/ranges-management',
      },
      {
        name: `${$t('pages.alter-code-types')}`,
        icon: '',
        isVisible: true,
        isExpanded: false,
        pathName: '/alter-code-types',
      },
      {
        name: `${$t('pages.dynamic-ranges')}`,
        icon: '',
        isVisible: true,
        isExpanded: false,
        pathName: '/dynamic-ranges',
      },
    ],
  },
  {
    tag: GENERALGROUPING,
    name: `${$t('sidebar.grouping')}`,
    icon: '',
    isVisible: true,
    isExpanded: false,
    children: [
      {
        name: `${$t('pages.materials')}`,
        icon: '',
        isVisible: true,
        isExpanded: false,
        pathName: '/grouping/material',
      },
      {
        name: `${$t('pages.trader-sites')}`,
        icon: '',
        isVisible: true,
        isExpanded: false,
        pathName: '/grouping/traderSite',
      },
      {
        name: `${$t('pages.alter-codes')}`,
        icon: '',
        isVisible: true,
        isExpanded: false,
        pathName: '/grouping/alterCode',
      },
      {
        name: `${$t('pages.customers')}`,
        icon: '',
        isVisible: true,
        isExpanded: false,
        pathName: '/grouping/customer',
      },
    ],
  },
  {
    tag: ROUTES,
    name: `${$t('sidebar.routes')}`,
    icon: '',
    isVisible: true,
    isExpanded: false,
    children: [
      {
        name: `${$t('pages.salespersons-types')}`,
        icon: '',
        isVisible: true,
        isExpanded: false,
        pathName: '/salespersons-types',
      },
      {
        name: `${$t('pages.salespersons-management')}`,
        icon: '',
        isVisible: true,
        isExpanded: false,
        pathName: '/salespersons-management',
      },
      {
        name: `${$t('pages.visit-plans')}`,
        icon: '',
        isVisible: true,
        isExpanded: false,
        pathName: '/visit-plans',
      },
      {
        name: `${$t('pages.route-definitions')}`,
        pathName: '/route-definitions',
        icon: '',
        isVisible: true,
        isExpanded: false,
      },
      {
        name: `${$t('pages.routes-management')}`,
        pathName: '/routes',
        icon: '',
        isVisible: true,
        isExpanded: false,
      },
      {
        name: `${$t('pages.sales-areas')}`,
        icon: '',
        isVisible: true,
        isExpanded: false,
        pathName: '/sales-areas',
      },
      {
        name: `${$t('pages.missed-visits-reasons')}`,
        icon: '',
        isVisible: true,
        isExpanded: false,
        pathName: '/missed-visits-reasons',
      },
    ],
  },
  {
    tag: DOCUMENTSMANAGEMENT,
    name: `${$t('sidebar.documents')}`,
    icon: '',
    isVisible: true,
    isExpanded: false,
    children: [
      {
        name: `${$t('pages.divisions')}`,
        icon: '',
        isVisible: true,
        isExpanded: false,
        pathName: '/divisions',
      },
      {
        name: `${$t('pages.document-series')}`,
        icon: '',
        isVisible: true,
        isExpanded: false,
        pathName: '/document-series',
      },
      {
        name: `${$t('pages.document-statuses')}`,
        icon: '',
        isVisible: true,
        isExpanded: false,
        pathName: '/document-statuses',
      },
      {
        name: `${$t('pages.payment-types')}`,
        icon: '',
        isVisible: true,
        isExpanded: false,
        pathName: '/payment-types',
      },
      {
        name: `${$t('pages.delivery-types')}`,
        icon: '',
        isVisible: true,
        isExpanded: false,
        pathName: '/delivery-types',
      },
      {
        name: `${$t('pages.document-types')}`,
        icon: '',
        isVisible: true,
        isExpanded: false,
        pathName: '/document-types',
      },
      {
        name: `${$t('pages.devices')}`,
        icon: '',
        isVisible: true,
        isExpanded: false,
        pathName: '/devices',
      },
      {
        name: `${$t('pages.mydata')}`,
        icon: '',
        isVisible: true,
        isExpanded: false,
        pathName: '/mydata',
      },
      {
        name: `${$t('pages.distribution-channels')}`,
        icon: '',
        isVisible: true,
        isExpanded: false,
        pathName: '/distribution-channels',
      },
      {
        name: $t('pages.validation-logger'),
        icon: '',
        isVisible: true,
        isExpanded: false,
        pathName: '/validation-logger',
      },
    ],
  },
  {
    tag: TPTRADEPOLICYMANAGEMENT,
    name: `${$t('sidebar.prices')}`,
    icon: '',
    isVisible: true,
    isExpanded: false,
    children: [
      {
        name: `${$t('pages.price-catalogs')}`,
        icon: '',
        isVisible: true,
        isExpanded: false,
        pathName: '/price-catalogs',
      },
      {
        name: `${$t('pages.price-policies')}`,
        icon: '',
        isVisible: true,
        isExpanded: false,
        pathName: '/price-policies',
      },
      {
        name: `${$t('pages.vat-categories')}`,
        icon: '',
        isVisible: true,
        isExpanded: false,
        pathName: '/vat-categories',
      },
      {
        name: `${$t('pages.vat-levels')}`,
        icon: '',
        isVisible: true,
        isExpanded: false,
        pathName: '/vat-levels',
      },
      {
        name: `${$t('pages.vat-factors')}`,
        icon: '',
        isVisible: true,
        isExpanded: false,
        pathName: '/vat-factors',
      },
    ],
  },
  {
    tag: MANAGERREPORTING,
    name: `${$t('sidebar.reports')}`,
    icon: '',
    isVisible: true,
    isExpanded: false,
    children: [
      {
        name: `${$t('pages.reporting')}`,
        icon: '',
        isVisible: true,
        isExpanded: false,
        pathName: '/reporting',
      },
    ],
  },
  {
    tag: QUESTIONNAIRES,
    name: `${$t('sidebar.questionnaires')}`,
    icon: '',
    isVisible: true,
    isExpanded: false,
    children: [
      {
        name: `${$t('pages.questionnaires-management')}`,
        icon: '',
        isVisible: true,
        isExpanded: false,
        pathName: '/questionnaires-management',
      },
      {
        name: `${$t('pages.qst-actions')}`,
        icon: '',
        isVisible: true,
        isExpanded: false,
        pathName: '/qst-actions',
      },
      {
        name: `${$t('pages.questionnaires-report')}`,
        icon: '',
        isVisible: true,
        isExpanded: false,
        pathName: '/questionnaires-report',
      },
    ],
  },
  {
    tag: PRICECOLLECTION,
    name: `${$t('sidebar.priceCollection')}`,
    icon: '',
    isVisible: true,
    isExpanded: false,
    children: [
      {
        name: `${$t('pages.documents-management')}`,
        icon: '',
        isVisible: true,
        isExpanded: false,
        pathName: '/documents-management',
      },
      {
        name: `${$t('pages.price-collection-last-visit-values')}`,
        icon: '',
        isVisible: true,
        isExpanded: false,
        pathName: '/price-collection-last-visit-values',
      },
    ],
  },
  {
    tag: SALES,
    name: `${$t('sidebar.salesDocuments')}`,
    icon: '',
    isVisible: true,
    isExpanded: false,
    pathName: '/transactions/sales-documents',
    isFavoriteActive: true,
  },
  {
    tag: REPRESENTATIVES,
    name: `${$t('sidebar.representatives')}`,
    icon: '',
    isVisible: true,
    isExpanded: false,
    children: [
      {
        name: `${$t('pages.representatives')}`,
        icon: '',
        isVisible: true,
        isExpanded: false,
        pathName: '/representatives',
      },
      {
        name: `${$t('pages.representatives-transactions')}`,
        icon: '',
        isVisible: true,
        isExpanded: false,
        pathName: '/representatives-transactions',
      },
    ],
  },
]);

const activeMenu = ref<MenuItem[]>([]);

const companyLogo = ref<string | undefined>();
onMounted(async () => {
  const logo = localStorage.getItem('companyLogo');
  if (logo && logo.length > 0) companyLogo.value = logo;
  generateMenu();
});

function generateMenu() {
  let installationModules: ModuleInstallation[] = [];
  const storedInstallation = localStorage.getItem('installationModules');
  if (storedInstallation)
    installationModules = JSON.parse(storedInstallation) as ModuleInstallation[];

  const distinctInstallationApplicationNames = Array.from(
    new Set(installationModules.map((x) => x.applicationName))
  );

  let appMenuItems = applicationsMenuItems.value.filter((a) => {
    if (!a.tag) return false;
    const tagNormalized = a.tag.replace(/\s+/g, '').toLowerCase();
    return distinctInstallationApplicationNames.some(
      (name) => name && name.replace(/\s+/g, '').toLowerCase() === tagNormalized
    );
  });

  for (const menuItem of appMenuItems) {
    const menuItemTagNormalized = menuItem.tag?.replace(/\s+/g, '').toLowerCase();

    // Get installation modules for this app
    const appInstallationModules = installationModules.filter(
      (m) =>
        m.applicationName &&
        m.applicationName.replace(/\s+/g, '').toLowerCase() === menuItemTagNormalized
    );

    // Sort by order (modules without order go to the end)
    const sortedModules = appInstallationModules.sort((a, b) => {
      const aOrder = typeof a.order === 'number' ? a.order : Number.POSITIVE_INFINITY;
      const bOrder = typeof b.order === 'number' ? b.order : Number.POSITIVE_INFINITY;
      return aOrder - bOrder;
    });

    const distinctInstallationModuleNamesForApp = Array.from(
      new Set(sortedModules.map((m) => m.moduleName))
    );

    // Filter and order the menu items based on the sorted module names
    const orderedChildren: any[] = [];
    for (const moduleName of distinctInstallationModuleNamesForApp) {
      const matchingChild = modulesMenuItems.value.find((m) => {
        if (!m.tag) return false;
        const modTagNorm = m.tag.replace(/\s+/g, '').toLowerCase();
        return moduleName && moduleName.replace(/\s+/g, '').toLowerCase() === modTagNorm;
      });
      if (matchingChild) {
        orderedChildren.push(matchingChild);
      }
    }

    menuItem.children = orderedChildren;
  }

  menuItems.value = appMenuItems;
  activeMenu.value = menuItems.value;
}

const searchInput = ref('');
watch(searchInput, (newInput) => {
  if (activeTab.value == 'Menu')
    activeMenu.value =
      filterMenuItems(menuItems.value, newInput.toLocaleLowerCase()) ?? menuItems.value;
});

const sidebarid = ref<PerfectScrollbarExpose>();

function onMenuExpandCollapse() {
  menuCollapsed.value = !menuCollapsed.value;
  if (sidebarid.value && sidebarid.value.ps) sidebarid.value.ps.element.scrollTop = 0;
}

function leafItemClicked(item: MenuItem) {
  if (item.pathName) router.push(item.pathName);
  if (item.isExpanded === true) return;
  if (!item.children || item.children.length <= 0) {
    activeMenu.value.map((x) => {
      x.children?.map((y) => {
        if (y.children) {
          for (const z of y.children) {
            if (z.name === item.name) z.isExpanded = true;
            else z.isExpanded = false;
          }
        }
        return y;
      });
      return x;
    });
  }
}

function rootItemClicked(item: MenuItem) {
  if (menuCollapsed.value) menuCollapsed.value = false;
  else {
    activeMenu.value.map((x) => {
      if (x.name === item.name) {
        x.isExpanded = !x.isExpanded;
        return x;
      }
    });
  }
}

function favouriteClicked(item: MenuItem) {
  focusedMenuItem.value = item.name;
  selectedMenuItem.value = { name: item.name, pathName: item.pathName };
  showAddToMenuModal.value = true;
}

function filterMenuItems(items: MenuItem[], searchToken: string): MenuItem[] {
  if (!searchToken) return items;

  return items
    .map((x) => {
      if (x.name.toLocaleLowerCase().includes(searchToken)) return x;

      if (x.children) {
        const filteredChildren = filterMenuItems(x.children, searchToken);
        if (filteredChildren?.length) {
          const updated: MenuItem = { ...x, children: filteredChildren };
          return updated;
        }
      }
      return null;
    })
    .filter((x) => x !== null) as MenuItem[];
}

function filterFavoriteMenu(favoriteMenus: FavoriteMenu[], searchToken: string): FavoriteMenu[] {
  if (!searchToken) return favoriteMenus;

  return favoriteMenus
    .map((menu) => {
      if (menu.name.toLocaleLowerCase().includes(searchToken)) {
        return { ...menu, items: menu.items };
      }

      const filteredItems = menu.items.filter((item) =>
        item.name.toLocaleLowerCase().includes(searchToken)
      );
      if (filteredItems.length > 0) {
        return { ...menu, items: filteredItems };
      }

      return null;
    })
    .filter((menu) => menu !== null) as FavoriteMenu[];
}

// MY MENUS
const favoriteMenus = ref<FavoriteMenu[]>([]);

const favoritesMenu = ref<InstanceType<typeof FavoritesMenu> | null>(null);
function onFavoriteMenuUnpin(key: string) {
  if (favoritesMenu.value) {
    favoritesMenu.value.contextMenuTargetIndex = favoritesMenu.value.findMenuIndexByKey(key);
    favoritesMenu.value.onAction('unpin-menu');
  }
}

function onFavoritesUpdate(menus: FavoriteMenu[]) {
  favoriteMenus.value = menus;
}

function onFavoriteMenuClick(key: string) {
  if (favoritesMenu.value) favoritesMenu.value.onMenuClick(key);
}

function onFavoriteMenuRemoveItem(key: string, index: number) {
  if (favoriteMenus.value) favoritesMenu.value?.onRemoveMenuItem(key, index);
}

const showAddToMenuModal = ref(false);
const selectedMenu = ref<FavoriteMenu>();
const selectedMenuItem = ref<FavoriteMenuItem>();

async function onAddItemToMenu() {
  if (!favoritesMenu.value || !selectedMenuItem.value) return;
  if (selectedMenu.value) {
    favoritesMenu.value.onAddMenuItem(selectedMenu.value.key, selectedMenuItem.value);
    selectedMenuItem.value = undefined;
  } else {
    favoritesMenu.value.onAddMenu(undefined, undefined, [selectedMenuItem.value]);
    activeTab.value = 'Favourites';
  }

  showAddToMenuModal.value = false;

  selectedMenu.value = undefined;
}

const isContextMenuOpen = ref(false);

const clickLocation = ref({ x: 0, y: 0 });

const showContextMenu = (event: MouseEvent, key: string) => {
  clickLocation.value = {
    x: event.clientX,
    y: event.clientY,
  };
  if (favoritesMenu.value)
    favoritesMenu.value.contextMenuTargetIndex = favoritesMenu.value.findMenuIndexByKey(key);
  isContextMenuOpen.value = true;
};

const contextMenuOptions: ContextMenuOptions[] = [
  { name: 'tree.rename', action: 'rename', icon: 'fluent:rename-24-regular', color: '' },
  { name: 'tree.duplicate', action: 'duplicate', icon: 'fad:duplicate', color: '' },
  {
    name: 'Unpin from main menu',
    action: 'unpin-menu',
    icon: 'carbon:pin',
    color: '',
  },
  {
    name: 'tree.deleteItem',
    action: 'delete',
    icon: 'tdesign:delete-1',
    color: 'text-red-500',
  },
];

function onContextMenuAction(action: string) {
  if (favoritesMenu.value) favoritesMenu.value.onAction(action);
  if (action == 'rename') {
    nextTick(() => {
      if (renameInputMain.value) {
        renameInputMain.value[0].focus();
        renameInputMain.value[0].select();
      }
    });
  }
  isContextMenuOpen.value = false;
}

function onMenuRename() {
  if (favoritesMenu.value) favoritesMenu.value.onMenuRename();
}

const renameInputMain = ref<HTMLInputElement[] | null>(null);

const pinnedMenus = computed(() => {
  return favoriteMenus.value.filter((x) => x.pinnedMain);
});

function onTooltipButtonClick(tab: 'Favourites' | 'Menu') {
  activeTab.value = tab;
  menuCollapsed.value = false;
  if (sidebarid.value && sidebarid.value.ps) sidebarid.value.ps.element.scrollTop = 0;
}
</script>
